import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n';
import { supabase } from './integrations/supabase/client';
import { registerSW } from 'virtual:pwa-register';

// Initialize Supabase auth settings with better error handling
const initializeSupabaseAuth = async () => {
  try {
      // Try to get the current session
      const { data: { session }, error } = await supabase.auth.getSession();
      
      if (session) {
        console.log('Supabase auth initialized successfully from current session');
      } else {
        console.log('No active session found');
      }
    
      
  } catch (error) {
    console.error('Error initializing Supabase auth:', error);
  }
};

// Register service worker
const updateSW = registerSW({
  onNeedRefresh() {
    // This will be handled by the PWAUpdateNotification component
    const event = new CustomEvent('pwa:setUpdateSW', { detail: refreshApp });
    window.dispatchEvent(event);
    console.log('New content available, please refresh');
  },
  onOfflineReady() {
    console.log('App ready to work offline');
  },
  onRegistered(swRegistration) {
    console.log('SW registered: ', swRegistration);
  },
  onRegisterError(error) {
    console.error('SW registration error', error);
  }
});

const refreshApp = () => {
  window.location.reload();
}

// Initialize auth before rendering the app
initializeSupabaseAuth().then(() => {
  const root = createRoot(document.getElementById('root')!);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
